/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AppUserDto } from '../../models/app-user-dto';
import { UpdateUserProfileRequest } from '../../models/update-user-profile-request';

export interface UsersUserIdPut$Json$Params {
  userId: string;
      body?: UpdateUserProfileRequest
}

export function usersUserIdPut$Json(http: HttpClient, rootUrl: string, params: UsersUserIdPut$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AppUserDto>> {
  const rb = new RequestBuilder(rootUrl, usersUserIdPut$Json.PATH, 'put');
  if (params) {
    rb.path('userId', params.userId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AppUserDto>;
    })
  );
}

usersUserIdPut$Json.PATH = '/users/{userId}';
